import { useEffect, useState } from "react";
import { AES, enc } from "crypto-js";
import { apiPost, apiPut } from "./apiClient";

export const isPreferenceEnabled = (value) =>
  value === true || ["YES", "ON", "TRUE", "1"].includes(String(value || "").toUpperCase());

const getOrganizationId = () => {
  const encryptedId = localStorage.getItem("uniqueId1");
  if (!encryptedId) return "";
  try {
    return AES.decrypt(encryptedId, "1234567812345678").toString(enc.Utf8);
  } catch (error) {
    return "";
  }
};

export const fetchDocumentPreferences = async () => {
  const response = await apiPost("/fetchDiscountCheck", { uniqueId: getOrganizationId() });
  const data = await response.json();
  if (!response.ok || data.responseCode !== "200") {
    throw new Error(data.responseMessage || "Unable to load document preferences");
  }
  return data.responseMessage || {};
};

export const updateDocumentPreference = async (preference, enabled) => {
  const endpoint = preference === "hsnCheck" ? "updateHsnCheck" : "updateDiscountCheck";
  const response = await apiPut(`/${endpoint}`, {
    uniqueId: getOrganizationId(),
    userId: localStorage.getItem("userId"),
    [preference]: enabled ? "YES" : "NO",
  });
  const data = await response.json();
  if (!response.ok || data.status === "error") {
    throw new Error(data.responseMessage || "Unable to update document preference");
  }
  return data;
};

export const useDocumentPreferences = () => {
  const [preferences, setPreferences] = useState(null);

  useEffect(() => {
    let active = true;
    fetchDocumentPreferences()
      .then((data) => active && setPreferences(data))
      .catch((error) => {
        console.error("Unable to load document preferences:", error);
        if (active) setPreferences({});
      });
    return () => {
      active = false;
    };
  }, []);

  return preferences;
};
